<template>
  <div v-loading="loading">
    <el-card>
      <el-row
        v-for="(routeData,ii) in relRoutes"
        :key="routeData.id"
        style="padding:10px;"
        class="trans-row"
      >
        <el-col :lg="6">
          <h6>{{routeData.destination}}:{{routeData.named_pup_seq}} on {{dateFromUnxTime(routeData.date)}} PAX:{{routeData.pax}}</h6>
        </el-col>
        <el-col :lg="18">
          <routes-drafts :routeData="routeData" :showHeader="ii===0"></routes-drafts>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/acc_commons";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [commons],
  // name: "drafts-table",
  props: {
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    invoiceData: {
      type: Object,
      default: () => {},
    },
    businessId: {
      default: null,
    },
  },
  data() {
    return {
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      loading: false,
      relDrafts: [],
      relRoutes: [],
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    "$route.params.tripid": {
      async handler(val, oldval) {
        if (!val || val == oldval) return;
        this.loading = true;
        this.relRoutes = await api.getModxList("vue_route", {
          kind: "package",
          // mode: "sap_buisness",
          sort: "in",
          limit: 0,
          start: 0,
          tripid: val,
        });

        this.loading = false;
      },
      immediate: true,
    },
    // "TransDraft.id": {
    //   handler(val) {
    //     // if (!this.dialogVisible) return;
    //     if (!val) return;
    //     var dr = {};
    //     dr.exectime = "now";
    //     dr.time = "now";
    //     dr.businessId = this.TransDraft.businessId;
    //     dr.title = this.TransDraft.title;
    //     dr.isincome = this.TransDraft.isincome;
    //     dr.parentid = this.$route.query.selectedTrans;
    //     dr.in = this.$route.params.direction;
    //     dr.place = this.TransDraft.place;
    //     dr.tags = this.TransDraft.tags;
    //     this.newRow = dr;
    //     _log_("new val", this.newRow);
    //     this.$nextTick(() => {
    //       // this.$refs.drafts.appendTrackedData([
    //       //   { title: this.TransDraft.title }
    //       // ]);
    //       this.disabled = false;
    //     });
    //   },
    //   immediate: true
    // }
  },
  computed: {
    payMessage() {
      if (!this.TransDraft) return;
      var msg =
        "Δεν υπαρχει υπόλοιπο για αυτην την χρεωση (" +
        this.$theMoney(this.TransDraft.cost) +
        ")";

      const bl =
        parseFloat(this.TransDraft.cost) - parseFloat(this.TransDraft.balanse);
      if (bl > 0)
        msg =
          "Το υπολοιπο είναι <strong>" +
          this.$theMoney(bl) +
          "</strong> απο " +
          this.$theMoney(this.TransDraft.cost);

      return msg;
    },

    qrelDrafts() {
      _log_(
        ">>$route.query.selectedTrans>>>",
        this.$route.query.selectedTrans
      );
      if (this.$route.params.tripid)
        return {
          kind: "package",
          mode: "transdrafts",
          sort: "in",
          limit: 0,
          start: 0,
          tripid: this.$route.params.tripid,
        };
      else return null;
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      return [
        // { prop: "transactionId", width: "", editable: false, label: "id" },
        { prop: "title", width: "", editable: true, label: "Περιγραφη" },

        // {
        //   prop: "paymenttype",
        //   width: "120px",
        //   editable: true,
        //   label: "Πηρωμη σε",

        //   editorcomponent: {
        //     is: "s-tag-select",
        //     allowAdd: false,
        //     options: [
        //       { value: "cash", label: "Μετρητα" },
        //       { value: "bank", label: "Τραπεζα" },
        //       { value: "other", label: "Αλλο" },
        //       { value: "stock", label: "Πιστοτικο" },
        //       { value: "visa", label: "VISA" }
        //     ]
        //   }

        // },
        {
          prop: "tags",
          width: "220px",
          editable: true,
          label: "Κατηγορίες",
          editorcomponent: {
            is: "s-tag-select",
            allowAdd: false,
            multiple: true,
            filterable: true,
            placeholder: "Για τί πρόκειται...",

            endPoint: vm.qTags,
            valueProp: "tags",
            labelProp: "tags",
          },
        },

        {
          prop: "cost",
          editorcomponent: {
            is: "s-number",
          },
          width: "120px",
          editable: true,
          label: "Πληρωμη",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "transactionId",
          width: "60px",
          label: "X",
          onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponentFactory(row) {
            return {
              is: "el-button",
              icon: "el-icon-top-right",
              type: "success",
              circle: true,
              disabled: !row.id,
              title: "Click here for full edit",
            };
          },
          formatter(val, colDefs, row) {
            return "-";
          },
        },
      ];
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.loaded = true;

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    init() {},
    goTrans(e) {
      if (e.column.property == "transactionId") {
        if (!e.row.id) {
          return;
        }
        this.routeGo({
          name: "transaction",
          params: {
            transid: e.row.id,
            id: e.row.businessId,
            direction: "out",
            view: "contact",
          },
        });
      }
    },
    async handleRelDraft(data) {
      // _log_("UPPPP..", data);
      // if (!this.TransDraft) return;
      var dr = data.row;
      dr.exectime = "now";
      dr.time = "now";
      // dr.businessId = this.TransDraft.businessId;
      // dr.isincome = this.TransDraft.isincome;

      // dr.parentid = this.$route.query.selectedTrans;
      // dr.in = this.$route.params.direction;
      // dr.place = this.TransDraft.place;
      // // dr.isicome = this.$route.params.direction == "in";
      // dr.type = "payment";
      //
      if (dr) {
        const isNew = !dr.id;
        var d = await api.updateProcessor("transdrafts/update", dr);
        if (isNew && this.$refs.drafts)
          this.$refs.drafts.updateRow({ idx: dr.idx }, { id: d.id });
        // if (!isNew) this.$refs.drafts.updateRow(d);
        // else this.$refs.drafts.updateRow({ id: null }, d);
      }

      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script>
<style>
.trans-row {
  box-shadow: 0px 1px 2px;
}
</style>